export default "__VITE_PUBLIC_ASSET__4af12b82__"